exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:throughChat;src:url(" + require("../fonts/throughChat.eot?exnqbq") + ");src:url(" + require("../fonts/throughChat.eot?exnqbq") + "#iefix) format(\"embedded-opentype\"),url(" + require("../fonts/throughChat.ttf?exnqbq") + ") format(\"truetype\"),url(" + require("../fonts/throughChat.woff?exnqbq") + ") format(\"woff\"),url(" + require("../fonts/throughChat.svg?exnqbq") + "#throughChat) format(\"svg\");font-weight:400;font-style:normal}[class*=\" chat-icon-\"],[class^=chat-icon-]{font-family:throughChat;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.chat-icon-root_chat_send:before{content:\"\\E800\"}.chat-icon-root_chat_newMessage:before{content:\"\\E801\"}.chat-icon-root_chat_move:before{content:\"\\E802\"}.chat-icon-root_chat_openConversation:before{content:\"\\E803\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/css/throughChat.css
// module id = 428
// module chunks = 4